<template>
  <component
    :is="tag"
    :class="['title', theme, underlined && 'underlined', bolder && 'bolder']"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "Title",
  props: {
    tag: {
      type: String,
      default: "h",
      validator(value) {
        return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    },
    underlined: {
      type: Boolean,
      default: false
    },
    bolder: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: "primary"
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.title {
  &.primary {
    color: variables.$primary-color;
  }
  &.secondary {
    color: variables.$text-color;
  }
  &.underlined {
    position: relative;
    &::after {
      display: block;
      content: "";
      width: 50px;
      height: 7px;
      border-radius: 10px;
      background-color: variables.$primary-color;
      margin-top: calc(0.5em + 7px);
    }
  }
  &.bolder {
    font-family: "Futura Std Bold", sans-serif;
  }
}
</style>
